import { Component, OnInit } from '@angular/core';
import { QuotationRequestsComponent } from '../../../page-quotation-cart/pages/quotation-requests/quotation-requests.component';

@Component({
    selector: 'app-page-request-quotations-list',
    templateUrl: './page-request-quotations-list.component.html',
    styleUrls: ['./page-request-quotations-list.component.scss'],
    standalone: true,
    imports: [QuotationRequestsComponent]
})
export class PageRequestQuotationsListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
